import { render, staticRenderFns } from "./latest.vue?vue&type=template&id=076b0a44"
import script from "./latest.vue?vue&type=script&lang=ts"
export * from "./latest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports